<div
  ngbDropdown
  #notificationsDropdown="ngbDropdown"
  [autoClose]="'outside'"
  (openChange)="onDropdownOpenChange($event)"
  placement="bottom-end"
  ngbTooltip="Notifications"
  #notificationsTooltip="ngbTooltip"
  [style.display]="'inline-block'">
  <button
    ngbDropdownToggle
    id="notifications-dropdown-toggle"
    aria-label="notifications-header-icon"
    [attr.aria-describedby]="
      unreadCount > 0 ? 'notifications-unread-count' : null
    "
    class="btn-reset notification-bell"
    [class.unread]="unreadCount > 0"
    (click)="notificationsTooltip.close()">
    <i class="bi bi-bell-fill"></i>
    <span
      *ngIf="unreadCount > 0"
      id="notifications-unread-count"
      class="notification-badge"
      >{{ unreadCount > 99 ? "99+" : unreadCount }}</span
    >
  </button>

  <div
    ngbDropdownMenu
    aria-labelledby="notifications-dropdown-toggle"
    class="dropdown-menu dropdown-menu-end notifications-panel">
    <div class="notifications-list">
      <ng-container *ngIf="groupedNotifications.length; else emptyState">
        <div
          *ngFor="let group of groupedNotifications; trackBy: trackByGroupLabel"
          class="notification-group">
          <div class="notification-group-label">{{ group.label }}</div>
          <a
            *ngFor="
              let notification of group.items;
              trackBy: trackByNotificationId
            "
            href="javascript:void(0)"
            (click)="goToNotificationSource(notification)"
            class="notification-row d-flex"
            [class.unread]="!notification.date_shown">
            <div class="avatar-with-badge position-relative align-self-start">
              <div
                class="avatar-ring"
                [style.border-color]="
                  typeMeta[notification.notification_type]?.color
                ">
                <app-avatar
                  avatarSize="medium"
                  [showBorder]="false"
                  [profileLinkActive]="!!notification.actorUser"
                  [hideTooltip]="!notification.actorUser"
                  [profile]="notification.actorUser?.profile || null"
                  [avatarData]="getActorAvatarData(notification)" />
              </div>
              <span
                class="type-badge"
                [style.background-color]="
                  typeMeta[notification.notification_type]?.color
                ">
                <i
                  class="bi bi-{{
                    typeMeta[notification.notification_type]?.icon
                  }}"></i>
              </span>
            </div>
            <div class="notification-content ms-2 flex-grow-1 mb-2">
              <div class="d-flex justify-content-between align-items-baseline">
                <div class="fw-bold notification-title">
                  {{ notificationTitle(notification) }}
                </div>
                <div class="notification-time text-muted fs-11">
                  {{
                    notification.notification_date | formatDistanceToNow : true
                  }}
                </div>
              </div>
              <div
                class="notification-message"
                [class.expanded]="expandedIds.has(notification.id)">
                {{ notification.notification_message }}
              </div>
              <button
                *ngIf="messageIsLong(notification.notification_message)"
                class="notification-expand-btn"
                (click)="toggleExpand(notification.id, $event)">
                {{
                  expandedIds.has(notification.id) ? "show less" : "show more"
                }}
              </button>
            </div>
          </a>
        </div>
      </ng-container>
      <ng-template #emptyState>
        <div class="notifications-empty text-center py-5">
          Nothing to see here yet.
        </div>
      </ng-template>
    </div>

    <a
      href="javascript:void(0)"
      (click)="goToAllNotifications()"
      class="notifications-see-all d-block text-center p-2 fs-14">
      See all notifications
    </a>
  </div>
</div>
